import { css } from "styled-components";
// apply all: unset but restore box-sizing to inherit
export const localReset = () => css `
  all: unset;
  box-sizing: inherit;
`;
